import { useNavigate } from '@lib/react-router-dom'

import { ResponseError, instanceOfAxiosError } from '@utils/ApiClient'

export const handleBaseTwoFactorErrors = (
  error: unknown,
  navigate: ReturnType<typeof useNavigate>
): void | boolean => {
  if (instanceOfAxiosError((error as ResponseError)?.response)) {
    const errorResponse = (error as ResponseError).response.response?.data
    const cooldownInMinutes = errorResponse?.properties?.cooldownInMinutes

    switch (errorResponse?.code) {
      case 'two_factor_auth_resend_code_cannot_be_executed':
        const cooldownInSeconds = errorResponse?.properties?.remainingSeconds
        navigate('/profile/security-settings', {
          state: { newCodeCantBeSent: true, cooldownInSeconds },
        })
        return true
      case 'two_factor_auth_too_many_resend_code_attempts':
        navigate('/profile/security-settings', {
          state: { isTooManyResendAttempts: true, cooldownInMinutes },
        })
        return true
      case 'two_factor_auth_too_many_insert_resend_code_attempts':
        navigate('/profile/security-settings', {
          state: { isTooManyCodeInsertAttempts: true, cooldownInMinutes },
        })
        break
      case 'two_factor_authentication_invalid_token':
        navigate('/profile/security-settings')
        break
      case 'two_factor_authentication_expired_token':
        navigate('/profile/security-settings')
        break
      default:
        return
    }
  }
}
